import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CurrentSelfieState, selfieFeatureKey } from '../reducers/selfie.reducer';
import * as fromEmployeeMainReducer from '../employee-detail.reducer';
import * as currentSelfieState from '../reducers/selfie.reducer';

//#region Employee detail ROOT STATE
export const getMainEmployeeState = createFeatureSelector<fromEmployeeMainReducer.State, CurrentSelfieState>(
  fromEmployeeMainReducer.employeeDetailFeatureKey
);
//#endregion

//#region Employee Selfie SUB STATE
export const getCurrentSelfieState = createSelector(getMainEmployeeState, state => state[selfieFeatureKey]);
//#endregion

//#region CURRENT SELFIE SELECTORS
export const getCurrentSelfieRequest = createSelector(getCurrentSelfieState, currentSelfieState.getCurrentSelfieRequest);
export const getCurrentSelfieSuccess = createSelector(getCurrentSelfieState, currentSelfieState.getCurrentSelfieResponse);
export const getCurrentSelfieFailure = createSelector(getCurrentSelfieState, currentSelfieState.getCurrentSelfieFailure);
//#endregion
